import {connect} from 'react-redux'
import CashReload from '../components/CashReloadView'
import _ from 'lodash'

import {changeStep} from "../../../../layouts/Content/modules/step";
import {appSetVal, appSetObj, appSetServerVal, checkFields, appCall} from '../../../../store/application'
import {updateAmounts, submitTransaction, checkBalance, resetCardOperations, updateCardData} from "../modules/cashreload";
import {resetScannerResult} from "../../../Devices/Scanner/modules/scanner";

const mapDispatchToProps = {
  updateAmounts: updateAmounts,
  appSetVal: appSetVal,
  appSetObj: appSetObj,
  appSetServerVal: appSetServerVal,
  changeStep: changeStep,
  checkFields: checkFields,
  appCall: appCall,
  submitTransaction: submitTransaction,
  resetScannerResult: resetScannerResult,
  checkBalance: checkBalance,
  resetCardOperations: resetCardOperations,
  updateCardData: updateCardData
};

const mapStateToProps = (state) => {
  const {ready_to_submit,
    check_balance_done, check_balance_status, check_balance_response_text,
    balance_amount, original_amount, prevalins_done, prevalins_status, prevalins_response_text} = state.app.x_data;

  const {title, icon} = state.app.product_data;

  const {
    cardAccountNumber,
    cardHolderName,
    cardTrack1,
    cardTrack2
  } = state.scanner;

  const {customer_id} = state.customer;

  const showBalance = check_balance_done && check_balance_status;

  return {
    icon,
    title,
    customer_id,
    ready_to_submit: !ready_to_submit,
    account: cardAccountNumber,
    cardholder_name: cardHolderName,
    check_balance_response_text: check_balance_response_text,
    balance_amount: balance_amount,
    show_balance: showBalance,
    check_balance_error: check_balance_done && !check_balance_status,
    can_check_balance: !!(cardAccountNumber && cardTrack1 && cardTrack2 && !showBalance),
    card_track1: cardTrack1,
    card_track2: cardTrack2,
    original_amount,
    prevalins_error: prevalins_done && !prevalins_status,
    prevalins_response_text: prevalins_response_text
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CashReload)


// WEBPACK FOOTER //
// ./src/components/Applications/CashReload/containers/CashReloadContainer.js